import React from 'react';
import { Grid, Alert, AlertTitle } from '@mui/material';
import { Markup } from 'interweave';

export default function Message({ props }) {

	return (
		<Grid item xs={12}>
			<Alert sx={{ fontSize: 16 }} severity={props.type}>
				{props.titre &&
					<AlertTitle sx={{ fontWeight: 600 }}>{props.titre}</AlertTitle>
				}
				<Markup content={props.message} />
				{props.contact &&
					<>
						<p>
							Du <b>Lundi</b> au <b>Vendredi</b> de <b>9:00</b> à <b>12:00</b> et de <b>14:00</b> à <b>17:00</b> par téléphone au <a href="tel:+33442998607">+33(0)4.42.99.86.07</a><br />
						</p>
						<p>
							Ou nous contacter directement par mail <a href='mailto:contact-clients@ellian.fr'>contact-clients@ellian.fr</a>
						</p>
					</>
				}
			</Alert>
		</Grid>
	);
}